export interface IBulkUpdateMap {
  [key: string]: IBulkUpdateItem;
}

export enum CloneType {
  UNKNOWN = 'U',
  CLONED = 'C',
  NEW = 'N',
}

export interface IBulkUpdateItem {
  key: string;
  enabled: boolean;
  displayTitle: string;
  genDisplayValue: () => string | JSX.Element;
  tab?: string;
  genType?: () => CloneType;
  defaultValue?: any;
}
